<template>
  <div class="container w-label">
    <form-header :pageTitle="pageTitle" @save="submitForm('ruleForm')"></form-header>
    <div class="form-body white-bg-radius" id="companyForm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
            <el-form-item label="送货分公司代号：" prop="companyCode">
                <el-input :disabled="!!ruleForm.id" v-model="ruleForm.companyCode" @focus="showDialog(1)" suffix-icon="el-icon-tickets" placeholder="请选择送货分公司代号" readonly>
                <i class="el-icon-error" v-if="ruleForm.companyCode&&!ruleForm.id" slot="append" @click.stop.prevent="clear('companyCode')"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="送货分公司名称：" >

                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.companyCode" placeholder="送货分公司代号" readonly></el-input>-->
                <span class="noBorderText">{{ruleForm.companyName}}</span>
            </el-form-item>
            <el-form-item label="仓别代号：" prop="warehouseCategory">
                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.warehouseCategory" placeholder="仓别" readonly></el-input>-->
                <span class="noBorderText">{{ruleForm.warehouseCategory}}</span>
            </el-form-item>
            <el-form-item label="仓别名称：" prop="address">
                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.address" placeholder="仓别名称" readonly></el-input>-->
                <span class="noBorderText">{{ruleForm.address}}</span>
            </el-form-item>
            <el-form-item label="物料代号：" >
              <el-input :disabled="!!ruleForm.id" v-model="ruleForm.prodNo" suffix-icon="el-icon-tickets" @focus="showDialog(2)" placeholder="请选择达能物料" readonly>
                <i class="el-icon-error" v-if="ruleForm.prodNo&&!ruleForm.id" slot="append" @click.stop.prevent="clear('prodName')"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="物料名称：" style="width:220px">
                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.prodNo" placeholder="达能物料编码" readonly></el-input>-->
                <div class="noBorderText">{{ruleForm.prodName}}</div>
            </el-form-item>
            <el-form-item label="产品大类代号：">
              <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.prodCategoryName" placeholder="产品大类" readonly></el-input>-->
              <span class="noBorderText">{{ruleForm.prodCategoryCode}}</span>
            </el-form-item>
            <el-form-item label="产品大类名称：">
                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.prodCategoryName" placeholder="产品大类" readonly></el-input>-->
                <span class="noBorderText">{{ruleForm.prodCategoryName}}</span>
            </el-form-item>

            <el-form-item label="保质期天数：">
                <!--<el-input :disabled="!!ruleForm.id" v-model="ruleForm.shelfLifeDay" :placeholder="shelfLifeDayHint" readonly></el-input>-->
                <div class="noBorderText">{{ruleForm.shelfLifeDay}}</div>
            </el-form-item>
            <el-form-item label="" style="margin-bottom:0;">
                <div class="statement">箱数下限和箱数上限可选择其中一项填写</div>
            </el-form-item>
            <el-form-item label="箱数下限：" class="amountLimit" prop="amountLowerLimit">
                <el-input v-model="ruleForm.amountLowerLimit" label="请输入箱数下限"></el-input>
            </el-form-item>
            <el-form-item label="箱数上限：" class="amountLimit" prop="amountUpperLimit">
                <el-input v-model="ruleForm.amountUpperLimit" label="请输入箱数上限"></el-input>
                <!--<el-input v-model="" placeholder="" :min="1" :step="1"></el-input>-->
            </el-form-item>
            <el-form-item label="备注：">
                <el-input v-model="ruleForm.remark" placeholder="备注"></el-input>
            </el-form-item>
        </el-form>
    </div>
    <select-dialog
        :modal-title="modalTitle"
        :dialog-visible="showDialogFlag"
        :data="data2"
        :default-props="defaultProps"
        @confirm-select-item="setSelectItem"
        @cancel="cancel">
    </select-dialog>
  </div>
</template>

<script>
  import formHeader from '../components/form-header'
  import selectDialog from '../components/select-dialog'
  import {
    methodPost,
    methodGet
  } from "../../api/request.js";
  // const isNumber = (rule, value, callback) => {
  //   // if (!value) {
  //   //   return callback(new Error('不能为空'));
  //   // }
  //   try {
  //     value -= 0;
  //   } catch (e) {
  //     callback(new Error('请输入数字值'));
  //   }
  //   if (!Number.isInteger(value)) {
  //     callback(new Error('请输入整数数字'));
  //   } if (value < 0) {
  //     callback(new Error('不能为小于0'));
  //   } else {
  //     callback();
  //   }
  // };
  // const isNumber2 = (rule, value, callback) => {
  //   try {
  //     value -= 0;
  //   } catch (e) {
  //     callback(new Error('请输入数字值'));
  //   }
  //   if (!Number.isInteger(value)) {
  //     callback(new Error('请输入整数数字'));
  //   } if (value < 0) {
  //     callback(new Error('不能为小于0'));
  //   } else {
  //     callback();
  //   }
  // };
  export default {
    components: {
      formHeader,
      selectDialog
    },
    data() {
      const _id = this.$route.query.id;
      const _pageTitle = `${_id ? '编辑' : '新增'}仓别产品配置清单`;
      const _hint = `${_id ? '' : '保质期天数'}`;
      return {
        showDialogFlag: false,
        currentInput: '',
        modalTitle: '',
        pageTitle: _pageTitle,
        shelfLifeDayHint: _hint,
        ruleForm: {
          id: _id,
          companyName: '',
          companyCode: '',
          warehouseCategory: '',
          address: '',
          prodName: '',
          prodNo: '',
          prodCategoryCode: '',
          prodCategoryName: '',
          shelfLifeDay: '',
          amountLowerLimit: '',
          amountUpperLimit: '',
          remark: ''
        },
        rules: {
          // companyName: [
          //   { required: true, message: '请选择送货分公司', trigger: 'blur' }
          // ],
          companyCode: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          warehouseCategory: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          prodName: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          prodCategoryCode: [
            { required: true, message: '请选择物料产品大类代号', trigger: 'blur' }
          ],
          prodCategoryName: [
            { required: true, message: '请选择物料产品大类名称', trigger: 'blur' }
          ],
          amountLowerLimit: [
            // { validator: isNumber, trigger: 'blur' }
          ],
          amountUpperLimit: [
            // { validator: isNumber2, trigger: 'blur' }
          ]
        },
        data2: [],
        defaultProps: {
          children: 'warehouseCategoryList',
          label: 'companyName'
        },
        companyData: [],
        materialData: []
      }
    },
    created() {
      this.getCompanyData()
      this.getMaterialData()
      if (this.ruleForm.id) {
        this.getEditPageInfo();
      }
    },
    methods: {
      clear(type) {
        this.ruleForm[type] = '';
        switch (type) {
          case "prodName":
            this.ruleForm.shelfLifeDay = '';
            this.ruleForm.prodNo = '';
            this.ruleForm.prodCategoryName = '';
            this.ruleForm.prodCategoryCode = ''
            break;
          case "companyCode":
            this.ruleForm.companyCode = ''
            this.ruleForm.companyName = ''
            this.ruleForm.warehouseCategory = ''
            this.ruleForm.address = ''
            break
        }
      },
      getEditPageInfo() {
        methodGet(`/warehouse/getDeliveryWarehouseProdConfigById/${this.ruleForm.id}`).then(res => {
          if (res.code === 0 && res.data) {
            const keys = Object.keys(this.ruleForm)
            keys.map(key => {
              this.ruleForm[key] = res.data[key];
            })
          }
        })
      },
      getCompanyData() {
        methodPost('/warehouse/findDeliveryWarehouseDropDownList').then(res => {
          this.companyData = this.cookOriginData(res.data)
        })
      },
      getMaterialData() {
        methodPost('/material/findMaterialTreeAllList').then(res => {
          this.materialData = res.data;
        })
      },
      // 对接口数据进行处理，以适应下拉选择组件
      cookOriginData(data) {
        return data.map(item => {
          return this.dealWithCategoryList(item)
        })
      },
      dealWithCategoryList(item) {
        item.warehouseCategoryList.map(item2 => {
          item2.companyCode = item2.warehouseCategory;
          item2.companyName = item2.address;
          if (item2.warehouseCategoryList) {
            return this.dealWithCategoryList(item2)
          } else {
            return item2
          }
        })
        return item
      },
      cancel() {
        this.showDialogFlag = false;
      },
      setSelectItem(val) {
        if (this.currentInput === 1) {
          this.ruleForm.companyName = val.parent.data.companyName
          this.ruleForm.companyCode = val.parent.data.companyCode
          this.ruleForm.warehouseCategory = val.data.warehouseCategory
          this.ruleForm.address = val.data.address
          // this.$refs.ruleForm.validateField(['companyCode', 'warehouseCategory', 'address']);
          const fieldsToValidate = ['companyCode', 'warehouseCategory', 'address'];
          const _self = this;
          Promise.all(fieldsToValidate.map(item => {
            const p = new Promise(function(resolve, reject) {
              _self.$refs['ruleForm'].validateField(item, (error) => {
                resolve(error)
              })
            });
            return p;
          })).then((data) => {
            console.info(data)
          })
        } else if (this.currentInput === 2) {
          const prodCategory = this.findRootParentCode(val)
          this.ruleForm.prodName = val.data.name
          this.ruleForm.prodNo = val.data.code
          this.ruleForm.prodCategoryCode = prodCategory.code
          this.ruleForm.prodCategoryName = prodCategory.name
          this.ruleForm.shelfLifeDay = val.data.shelfLifeNum
        }
        this.showDialogFlag = false;
      },
      findRootParentCode(item) {
        if (item.level === 1) {
          return { code: item.data.code, name: item.data.name }
        } else {
          return this.findRootParentCode(item.parent)
        }
      },
      showDialog(flag) {
        // flag，1表示仓别，2表示物料
        if (flag === 1) {
          this.modalTitle = '送货分公司仓别'
          this.defaultProps.children = 'warehouseCategoryList'
          this.defaultProps.label = 'companyName'
          this.data2 = this.companyData;
        } else if (flag === 2) {
          this.modalTitle = '达能物料'
          this.defaultProps.children = 'childrenList'
          this.defaultProps.label = 'name'
          this.defaultProps.searchName = ['code', 'name']
          this.data2 = this.materialData;
        }
        this.currentInput = flag;
        this.showDialogFlag = true;
      },
      submitForm(formName) {
        const reg = /^[+]{0,1}(\d+)$/;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.ruleForm.amountLowerLimit === '' && this.ruleForm.amountUpperLimit === '') {
              this.$message.error('箱数上限和箱数下限请至少填写一项')
              return false
            } else if (this.ruleForm.amountLowerLimit && !reg.test(this.ruleForm.amountLowerLimit)) {
              this.$message.error('箱数下限为正整数')
              return false
            } else if (this.ruleForm.amountUpperLimit && !reg.test(this.ruleForm.amountUpperLimit)) {
              this.$message.error('箱数上限为正整数')
              return false
            } else if (this.ruleForm.amountUpperLimit && this.ruleForm.amountLowerLimit && (this.ruleForm.amountUpperLimit - this.ruleForm.amountLowerLimit < 0)) {
              this.$message.error('箱数下限大于上限,请修改')
              return false
            } else {
              // 有id时表示是编辑页。调用更新保存，无时调用新增保存
              const URL = this.ruleForm.id ? '/warehouse/updateDeliveryWarehouseProdConfig' : '/warehouse/inserDeliveryWarehouseProdConfig'
              methodPost(URL, this.ruleForm).then(res => {
                if (res.code === 0) {
                  this.$message.success(`${this.ruleForm.id ? '保存' : '新增'}成功`)
                  this._gobackRefresh(this, this.$route.fullPath)
                } else {
                  this.$message.error(res.message || '保存出错，请稍后再试')
                }
              })
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }

    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

    .container {
        position: relative;
        display: flex;
        flex-direction: column;
        padding-left: 20px;

        .form-body {
            background-color: #fff;
            margin: 20px 20px 0 0;
            border-radius: 6px;
            padding-top: 20px;
            min-width: 940px;
            // 4.18
            margin-bottom:20px;
            .title {
                height: 20px;
                line-height: 20px;
                border-left: 4px solid #666;
                color: #666;
                font-size: 14px;
                font-weight: bold;
                margin: 20px 0;
                padding-left: 10px;
                margin-left: 40px;
            }
        }
        .form-body_header {
            padding-left: 40px;

            .title {
                margin-left: 0;
            }
        }
        .statement {
            font-size: 12px;
            color: #999;
            width: 220px;
        }
        .clear-btn-wrapper {
            position: absolute;
            top: 0;
            right:-18px;
            color: #909399;

        }

    }
</style>
<style>
#app #companyForm .el-form-item__content{
  width:260px;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/product-config-list/add.vue